import { type BillingStandaloneOnboardingAWSModel, type SaaSConsoleType } from "@doitintl/cmp-models";
import { type UpdateFields } from "@doitintl/models-any";

import { onboardingDocRef } from "../utils";

export async function updateStackCreationState(accountId: string, customerId: string, type: SaaSConsoleType) {
  const updateData: UpdateFields<BillingStandaloneOnboardingAWSModel> = {
    [`accounts.${accountId}.stackCreationState`]: "loading",
  };

  await onboardingDocRef(customerId, type).narrow<BillingStandaloneOnboardingAWSModel>().update(updateData);
}
